import { render, staticRenderFns } from "./UserHeaderDesktop.vue?vue&type=template&id=4c4bf17f&scoped=true&"
import script from "./UserHeaderDesktop.vue?vue&type=script&lang=js&"
export * from "./UserHeaderDesktop.vue?vue&type=script&lang=js&"
import style0 from "./UserHeaderDesktop.vue?vue&type=style&index=0&id=4c4bf17f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4bf17f",
  null
  
)

export default component.exports